module.exports = __webpack_public_path__ + "static/media/startingText_Patient.1743d552.md";